import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service'; 
@Component({
  selector: 'app-tips-for-commerce-students-pursuing-a-b-com-degree',
  templateUrl: './tips-for-commerce-students-pursuing-a-b-com-degree.component.html',
  styleUrls: ['./tips-for-commerce-students-pursuing-a-b-com-degree.component.scss']
})
export class TipsForCommerceStudentsPursuingABComDegreeComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;


  ngOnInit(): void {
  }

}
